import * as actions from "../monitor/actionsTypes";

const initialData = {
  loading: false,
  saveLoading: false,
  monitorLength: 0,
  monitor: [],
  monitorError: "",
  copiaError: "",
  dadoDeBaja: [],
  dadoDeBajaError: "",
  saveLoadingDeBaja: false,
};

export default function monitorOnBoardingReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_MONITOR:
      return { ...state, loading: action.payload };
    case actions.SAVE_LOADING_MONITOR:
      return { ...state, saveLoading: action.payload };
    case actions.SAVE_LOADING_DADO_DE_BAJA:
      return { ...state, saveLoadingDeBaja: action.payload };
    case actions.GET_MONITOR:
      return {
        ...state,
        monitor: action.payload.monitor,
        monitorLength: action.payload.monitorLength,
      };
      case actions.GET_DADO_DE_BAJA:
        return { ...state, dadoDeBaja: action.payload };
    case actions.GET_MONITOR_FAIL:
      return { ...state, monitorError: action.payload };
    case actions.COPIA_FAIL:
      return { ...state, copiaError: action.payload };
    case actions.DADO_DE_BAJA_FAIL:
      return { ...state, dadoDeBajaError: action.payload };

    default:
      return state;
  }
}
